/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { HealthSuccessEnum } from "./HealthSuccessEnum";
export const HealthResponse = core.serialization.object({
    status: HealthSuccessEnum,
});
